module.exports = __webpack_public_path__ + "static/img/15.1022a29a.png";